import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { ServicoRadioterapiaCnesContextService } from '../services/servico-radioterapia-cnes-context.service';

/**
 * Redireciona para a tela de vínculo de CNES quando o perfil não tem claim e há mais de um estabelecimento.
 */
export const servicoRadioterapiaCnesContextoGuard: CanActivateChildFn = (_route, state) => {
  const ctx = inject(ServicoRadioterapiaCnesContextService);
  const router = inject(Router);

  if (
    state.url.includes('contexto-estabelecimento')
    || state.url.includes('gestao-federal/onboard-analise')
    || state.url.includes('/dashboard')
    || state.url.includes('relatorios/servicos')
  ) {
    return true;
  }

  return ctx.ensureCnesContextValid().pipe(
    map((ok) => (ok ? true : router.parseUrl('/servico-radioterapia/contexto-estabelecimento')))
  );
};
